import React from 'react';
import "../App.css";
import './KontaktHeroSection.css';

function HomeHeroSection() {
	return (
		<div className="kontakt-hero-container">
			<h1>Kontakt</h1>
			<p></p>
		</div>

	);
}

export default HomeHeroSection;